import * as React from "react";
import clsx from "clsx";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { NanoUserWithPicT } from "@talentpair/types/entities/user";
import { userService } from "@talentpair/api";
import { env, astralLink } from "@talentpair/env";
import { Box, Placard, Avatar, UserAvatar, Typography } from "@talentpair/quantic";
import { displayFullName } from "@talentpair/entities/user";

export type DataRowProps = {
  noborder?: boolean;
  label: string;
  data: React.ReactNode;
};

export function DataRow({ noborder, label, data }: DataRowProps): React.ReactElement {
  return (
    <Box
      variant="row"
      layout="center-start"
      space={3}
      className={clsx("py2", noborder ? undefined : "lt-grey-border-top")}
    >
      <Typography variant="overline" color="grey.500" style={{ width: 90, flex: "none" }}>
        {label}
      </Typography>
      <Typography variant="body2" semibold>
        {data}
      </Typography>
    </Box>
  );
}

export type UserDataCardProps = {
  title: string;
  className?: string;
  style?: React.CSSProperties;
};

export function UserDataCard({
  title,
  children,
  className,
  style,
}: React.PropsWithChildren<UserDataCardProps>): React.ReactElement {
  return (
    <Box className={clsx("br2 lt-grey-border px3 bg-white", className)} style={style}>
      <Placard
        avatar={
          <Avatar
            variant="circular"
            fill="icon"
            Icon={PermIdentityOutlinedIcon}
            size="md"
            color="grey.500"
            background="grey.200"
            className="mr3"
          />
        }
        primary={title}
        className="px2 py3"
      />
      {children}
    </Box>
  );
}

export function UserAvatarDataCard({
  user,
  role,
  children,
  className,
  style,
}: React.PropsWithChildren<{
  user: NanoUserWithPicT | null;
  role: string;
  className?: string;
  style?: React.CSSProperties;
}>): React.ReactElement {
  return user ? (
    <Box className={clsx("br2 lt-grey-border px3 bg-white", className)} style={style}>
      <Placard
        avatar={<UserAvatar ringed={false} user={user} className="mr3" />}
        primary={displayFullName(user)}
        href={
          userService.isRecruiter() ? env.gettysburgUrl(astralLink.toUserHome(user.id)) : undefined
        }
        secondary={role}
        className="px2 py3"
      />
      {children}
    </Box>
  ) : (
    <UserDataCard title={role} className={className} style={style}>
      {children}
    </UserDataCard>
  );
}
